import API from "../configs/axiosInstance";

const signIn = (data = {}) => {
	return API({
		url: `/v1/token/login`,
		method: 'POST',
		data,
	});
};

const signUp = (data = {}) => {
	return API({
		url: '/account-service/v1/register',
		method: 'POST',
		data,
	});
};

const twoFactor = (data) => {
	return API({
		url: `/v1/token?code=${data}`,
		method: 'POST'
	});
};

const login = (data = {}) => {
	return API({
		url: '/account-service/v1/users/current-user',
		method: 'GET',
		data,
		headers: {
			Authorization: `Bearer ${data}`,
		},
	});
};

const getModules = () => {
	return API({
		url: '/account-service/v1/user-groups/permitted-modules',
		method: 'GET',
	});
};

const getThirdPartyMe = (accessToken) => {
	return API({
		url: '/account-service/v1/third-party-portal/me',
		method: 'GET',
		headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
	});
};

const getThirdPartyReport = () => {
	return API({
		url: '/account-service/v1/third-party-portal/report',
		method: 'GET',
	});
};

const getThirdPartyVulnerabilities = () => {
	return API({
		url: '/account-service/v1/third-party-portal/vulnerabilities',
		method: 'GET',
	});
};

const getThirdPartyDigitalFootprint = () => {
	return API({
		url: '/account-service/v1/third-party-portal/digital-footprint',
		method: 'GET',
	});
};

const acceptThirdPartyTerms = (data = {}) => {
	return API({
		url: '/account-service/v1/third-party-portal/accept-terms',
		method: 'POST',
		data,
	});
};

const resetPasswordMail = (data = {}) => {
	return API({
		url: `/account-service/v1/users/start-update-password?email=${data}`,
		method: 'POST',
	});
};

const resetPasswordVerification = (data = {}) => {
	return API({
		url: `/account-service/v1/users/verify-update-password-code?code=${data?.code}&mail=${data?.email}`,
		method: 'POST',
	});
};
const resetPasswordConfirm = (data = {}) => {
	return API({
		url: `/account-service/v1/users/update-password`,
		method: 'PUT',
		data
	});
};

const authService = {
	signIn,
	signUp,
	twoFactor,
	login,
	getModules,
	getThirdPartyMe,
	getThirdPartyReport,
	getThirdPartyVulnerabilities,
	getThirdPartyDigitalFootprint,
	acceptThirdPartyTerms,
	resetPasswordMail,
	resetPasswordVerification,
	resetPasswordConfirm
};

export default authService;
